import OfflineCard from "client/views/ChannelView/components/OfflineCard"
import { getUpcomingShows } from "client/views/ChannelView/components/UpcomingShowsList"

import { useChannelContext } from "../channel"

import MainView from "./MainView"

import styles from "./embedView.module.css"

export const EmbedView = () => {
  const { live, scheduledShows } = useChannelContext()

  const upcomingShows = getUpcomingShows(scheduledShows)

  // If the channel isn't currently live & has an upcoming show,
  // display a card for the next scheduled show.
  if (!live && upcomingShows.length >= 1) {
    return (
      <div className={styles.offlineCardContainer}>
        <OfflineCard compactMode={true} />
      </div>
    )
  }

  // Otherwise, display the MainView, which contains the stream when live,
  // and just displays a placeholder image when not live.
  return <MainView />
}

export default EmbedView
